export const SET_SHOULD_RENDER_AS_MOBILE = 'SET_SHOULD_RENDER_AS_MOBILE';
export const SET_IN_PAGE_SEARCH_VALUE = 'SET_IN_PAGE_SEARCH_VALUE';
export const SET_IS_IN_PAGE_SEARCH_DISPLAYED = 'SET_IS_IN_PAGE_SEARCH_DISPLAYED';
export const SET_IS_NEEDS_REFRESH_DISPLAYED = 'SET_IS_NEEDS_REFRESH_DISPLAYED';
export const SET_SECTION_SELECTED_CONTENT = 'SET_SECTION_SELECTED_CONTENT';

export const API_FEED_REQUEST = 'API_FEED_REQUEST';
export const API_FEED_RECEIVE_SUCCESS = 'API_FEED_RECEIVE_SUCCESS';
export const API_FEED_RECEIVE_FAILURE = 'API_FEED_RECEIVE_FAILURE';

export const SET_APPLIED_TAG_IDS_BY_CATEGORY_ID_FOR_GRID_SECTION_FILTER = 'SET_APPLIED_TAG_IDS_BY_CATEGORY_ID_FOR_GRID_SECTION_FILTER';

export const SET_CONSENT_PROPS = 'SET_CONSENT_PROPS';

export const SET_ACCORDION_STATE_BY_SECTION_ID = 'SET_ACCORDION_STATE_BY_SECTION_ID';
export const SET_ACTIVE_TAB_ID = 'SET_ACTIVE_TAB_ID';
